import { render, staticRenderFns } from "./SingleProduct.vue?vue&type=template&id=6388b539&scoped=true&"
import script from "./SingleProduct.vue?vue&type=script&lang=ts&"
export * from "./SingleProduct.vue?vue&type=script&lang=ts&"
import style0 from "./SingleProduct.vue?vue&type=style&index=0&id=6388b539&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6388b539",
  null
  
)

export default component.exports